import { Block } from "../../factories/types";
import { ClientHeader } from "./ClientHeader";

export const Header: Block<'header'> = ({ data }) => <ClientHeader header={data} />;